import { format, addMinutes } from 'date-fns';

export const DurationByMinutes = (totalMinutes) => {
    const minutes = totalMinutes % 60;
    const hours = (totalMinutes - minutes) / 60;
    const days = hours / 60;
    return days >= 1
        ? `${days} day`
        : hours === 0
        ? `${minutes} min`
        : minutes === 0
        ? `${hours} ${hours === 1 ? 'hr' : 'hrs'}`
        : `${hours} ${hours === 1 ? 'hr' : 'hrs'} ${minutes} min`;
};

export const DateToLocalString = (date: Date) => format(date, 'MM/dd/yyyy');

export const DateUTCToLocalString = (date: Date) => format(new Date(`${date?.toString()}Z`), 'MM/dd/yyyy');

export const DateToCalendarTimeString = (date: Date) => format(new Date(date), 'h:mma')?.toLowerCase();

export const AddMinutesToDate = (date: Date, duration: number) => addMinutes(date, duration);

export const DateTimeUTCToLocalString = (date: Date) => format(new Date(`${date?.toString()}Z`), 'MM/dd/yyyy hh:mm a');

export const DateToUTCString = (date) => new Date(date).toUTCString();

export const GetLocalTimeZoneStandardName = () =>
    new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'long' }).substring(4);

export const DateToDayTimeString = (date: Date) => format(date, 'dd');

export const CalculateAge = (birthDate: Date): string => {
    const now = new Date();

    const years = now.getFullYear() - birthDate.getFullYear();
    const months = now.getMonth() - birthDate.getMonth();
    const days = now.getDate() - birthDate.getDate();

    const fullYears = months < 0 || (months === 0 && days < 0) ? years - 1 : years;
    const fullMonths = getMonthDifference(birthDate, now) - (days < 0 ? 1 : 0);
    const fullDays = Math.floor((now.getTime() - birthDate.getTime()) / (1000 * 60 * 60 * 24));

    // Less than 1 month — show days
    if (fullMonths < 1) {
        return `${fullDays} ${fullDays === 1 ? 'Day' : 'Days'}`;
    }

    // Less than 1 years — show months
    if (fullYears < 1) {
        return `${fullMonths} ${fullMonths === 1 ? 'Month' : 'Months'}`;
    }

    // 1 year and above — show years
    return `${fullYears} ${fullYears === 1 ? 'Year' : 'Years'}`;
};

export const getMonthDifference = (startDate: Date, endDate: Date): number => {
    return endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());
};

export const GetLocalTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const CompareDateWithoutTime = function (fromDate: Date, toDate: Date) {
    const startDate = new Date(fromDate);
    const EndDate = new Date(toDate);
    startDate.setHours(0, 0, 0, 0);
    EndDate.setHours(0, 0, 0, 0);

    return EndDate >= startDate;
};
